(() => {
  const bindFaq = (scope = document) => scope.querySelectorAll('.faq-trigger').forEach((button) => {
    if (button.dataset.cocoonyBound) return;
    button.dataset.cocoonyBound = 'true';
    button.addEventListener('click', () => {
      const item = button.closest('.faq-item') || button.parentElement;
      const answer = item && (item.querySelector('.faq-answer, .faq-content, [data-faq-answer]') || button.nextElementSibling);
      const open = button.getAttribute('aria-expanded') === 'true';
      button.setAttribute('aria-expanded', String(!open));
      if (answer) answer.hidden = open;
      item && item.classList.toggle('is-open', !open);
    });
  });
  const bindOfferButtons = (scope = document) => scope.querySelectorAll('.main-product-atc').forEach((button) => {
    if (button.dataset.cocoonyBound) return;
    button.dataset.cocoonyBound = 'true';
    button.addEventListener('click', () => document.querySelector('#offers, .product-form, form[action^="/cart/add"]')?.scrollIntoView({behavior:'smooth', block:'center'}));
  });
  const init = () => { bindFaq(); bindOfferButtons(); };
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init) : init();
  document.addEventListener('shopify:section:load', (event) => { bindFaq(event.target); bindOfferButtons(event.target); });
})();
